export const KOR_STATUS: Record<string, string> = {
  requested: "요청됨",
  pending: "요청됨",
  approved: "승인됨",
  complete: "결제완료",
  completed: "결제완료",
  failed: "실패",
  rejected: "거절됨",
};

export function toKorStatus(s?: string | null) {
  const key = String(s || "").toLowerCase();
  return KOR_STATUS[key] ?? s ?? "-";
}
